import axios from 'axios';
import MainLayout from "@/components/layout/MainLayout.vue";
import StarRating from "vue-star-rating";
import Pagination from "laravel-vue-pagination";
import VueSlider from "vue-slider-component";
import DatePicker from "vue2-datepicker";
import "vue-slider-component/theme/default.css";
import AdvancedLaravelVuePaginate from 'advanced-laravel-vue-paginate';
import 'advanced-laravel-vue-paginate/dist/advanced-laravel-vue-paginate.css';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import { mapGetters } from "vuex";
import LightBox from 'lightbox2';
import 'lightbox2/dist/css/lightbox.css';
import { ConvertNumService } from '@/assets/js/convertNumberService.js';
import moment from "moment";
import ContentConfirmModal from '../../components/upload/ContentConfirmModal.vue';

const convertNumberService = new ConvertNumService();

export default {
    name: "contentGroup",
    components: {
        MainLayout,
        StarRating,
        Pagination,
        DatePicker,
        VueSlider,
        AdvancedLaravelVuePaginate,
        Loading,
        LightBox,
        ContentConfirmModal,
    },

    data() {
        return {
            courses: {
                course_id: "",
                course_title: "",
                course_explanation: "",
                course_details: "",
                certificate: "",
                update_time: "",
                name: "",
                teacher_id: "",
                rate: 0,
                experience: "",
                defaultPic: "",
                course_type: ""
            },
            contents: {},
            lastPage: "",
            currentPage: "",
            courseId: this.$route.params.id,
            currentPagePagination: 1,
            dialog1: {
                title: "အတည်ပြုချက်",
                text: "ဤသင်တန်းအတွက်သာ ဖျက်လိုပါသလား ဒါမှမဟုတ် အားလုံးကနေ အပြီးသတ် ဖျက်လိုပါသလား။",
                buttons: [
                    { label: "ဤသင်တန်းသာ ဖျက်မည်", handler: this.deleteForOne},
                    { label: "အားလုံးမှ ဖျက်မည်", handler: this.deleteForAll }
                ]},
            dialog2: {
                title: '',
                text: '',
                buttons: [
                    { label: "သေချာပါသည်", handler: this.dialog2Confirm },
                    { label: "မသေချာပါ", handler: () => this.$modal.hide("dialog2") }
                ],
                payload: null,
                isDeleteAll: null,
            }
        }
    },
    computed: {
        ...mapGetters(["teacherId", "studentId", "userType"]),
    },

    methods: {
        getContentList(page = 1) {
            this.currentPagePagination = page;
            axios.get("my/course/" + this.$route.params.id + "/content-gp?page=" + page)
                .then((response) => {
                    this.contents = response.data;
                    if (this.contents.data.length == 0 && page > 1) {
                        this.getContentList(1);
                    }
                    this.contents.total = convertNumberService.convertEng2Mm(this.contents.total);
                    this.lastPage = convertNumberService.convertEng2Mm(this.contents.last_page);
                    this.currentPage = convertNumberService.convertEng2Mm(this.contents.current_page);
                })
                .catch((error) => {
                    if (error.response.status == 404) {
                        this.$router.push({
                            name: 'notFound'
                        });
                    }
                    if (error.response.status == 403) {
                        this.$router.push({
                            name: 'forbidden'
                        });
                    }
                    if (error.response.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('/');
                    }
                    console.clear();
                });
        },

        getCourseDetail() {
            axios.get("my/course/" + this.$route.params.id)
                .then((response) => {
                    this.courses = response.data;
                })
                .catch((error) => {
                    if (error.response.status == 404) {
                        this.$router.push({
                            name: 'notFound'
                        });
                    }
                    if (error.response.status == 403) {
                        this.$router.push({
                            name: 'forbidden'
                        });
                    }
                    if (error.response.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('/');
                    }
                    console.log("Course Detail API Error", error);
                });
        },

        contentGroupDelete(contentGroupId) {
            const currentPagePagination = this.currentPagePagination;
            axios.post("my/course/" + this.$route.params.id + "/content-gp/" + contentGroupId + "/delete", { params: { is_delete_all: this.dialog2.isDeleteAll ? 1 : 0 } })
                .then((response) => {
                    if (response.data.status == 200) {
                        this.$notification.success("လုပ်ဆောင်မှု အောင်မြင်ပါသည်။", {
                            timer: 3,
                            position: 'bottomCenter'
                        });
                        this.getContentList(currentPagePagination);
                        this.getCourseDetail();
                    } if (response.data.status == 404) {
                        this.$notification.success("Content Group No Exist Yet!.", {
                            timer: 3,
                            position: 'bottomCenter'
                        });
                    } if (response.data.status == 400) {
                        this.$notification.error("လုပ်ဆောင်မှု မအောင်မြင်ပါ။", {
                            timer: 3,
                            position: "bottomCenter"
                        });
                    }
                })
                .catch((error) => {
                    this.getContentList(currentPagePagination);
                    this.getCourseDetail();
                    if (error.response.status == 404) {
                        this.$router.push({
                            name: 'notFound'
                        });
                    }
                    if (error.response.status == 403) {
                        this.$router.push({
                            name: 'forbidden'
                        });
                    }
                    if (error.response.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('/');
                    }
                    if (error) {
                        this.$notification.error("လုပ်ဆောင်မှု မအောင်မြင်ပါ။", {
                            timer: 3,
                            position: "bottomCenter"
                        });
                    }
                });
        },

        confirmContentGroupDelete(contentGroupId) {
            this.dialog1.payload = contentGroupId;
            this.$modal.show('dialog1');
        },

        deleteForAll() {
            this.setDialog2("သတိပေးချက်", "သင်တန်းအားလုံးအတွက် ဖျက်လိုသည်မှာ သေချာပါသလား။", true)
        },

        deleteForOne() {
            this.setDialog2("သတိပေးချက်", "ဖျက်လိုသည်မှာ သေချာပါသလား။", false)
        },

        setDialog2(title, text, isDeleteAll) {
            this.dialog2.title = title;
            this.dialog2.text = text;
            this.dialog2.isDeleteAll = isDeleteAll;
            this.dialog2.payload = this.dialog1.payload;
            this.$modal.hide('dialog1');
            this.$modal.show('dialog2');
        },

        dialog2Confirm() {
            const id = this.dialog2.payload;
            this.contentGroupDelete(id);
            this.$modal.hide('dialog1');
            this.$modal.hide('dialog2');
        }
    },

    filters: {
        setMoment: function (date) {
            return moment(date).format("DD MMMM YYYY");
        }
    },

    mounted() {
        this.getContentList();
        this.getCourseDetail();
    }
};
